

import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";
import { AppDispatch } from "../store";
import { getApiUrl } from "../helpers/environmentHelper";
import { setIsWaitingStockStatus, setStockStatus } from "../slices/articleSlice";
import axios from "axios";
import { acquireApiToken } from "../helpers/apiTokenHelper";

export const checkStockStatus = (
  instance: IPublicClientApplication,
  account: AccountInfo | null,
  articleId: string
) =>
  async (dispatch: AppDispatch) => {
    const baseUrl = getApiUrl(window.location.hostname, 2);
    dispatch(setIsWaitingStockStatus(true));
    try {
      if (account) {
        const response = await acquireApiToken(instance, account);
        if (response) {
          const result = await axios.get(`${baseUrl}/articles/${articleId}/check-stock`, {
            timeout: 10000,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${response.accessToken}`,
            },
          });
          dispatch(setStockStatus(result.data as string));
          dispatch(setIsWaitingStockStatus(false));
          return result.data;
        }
      }
      dispatch(setStockStatus(null));
      dispatch(setIsWaitingStockStatus(false));
    } catch (error) {
      dispatch(setStockStatus(null));
      dispatch(setIsWaitingStockStatus(false));
      console.log(error);
    }
  };